import MemberService from '@/api/MemberService';

const state = {
  selectedMemberEmployers: null,
  selectedEmployer: null,
};

const getters = {};

const actions = {
  currentMemberEmployers({ commit }) {
    return MemberService.getCurrentMemberEmployers().then((response) => {
      commit('selectedMemberEmployers', response.data);
    });
  },
  currentMemberEmployer({ commit }, id) {
    return MemberService.getCurrentMemberEmployer(id).then((response) => {
      commit('selectedEmployer', response.data);
    });
  },
  saveMemberEmployer({ commit }, args) {
    return MemberService.saveCurrentMemberEmployer(
      args.id,
      args.localEmployer,
    ).then(() => {
      commit('selectedEmployer', args.localEmployer);
    });
  },
  deleteMemberEmployer({ commit }, id) {
    return MemberService.deleteCurrentMemberEmployer(id).then(() => {
      commit('selectedEmployer', null);
    });
  },
  addMemberEmployer(context, data) {
    return MemberService.addCurrentMemberEmployer(data);
  },
};

const mutations = {
  selectedMemberEmployers(state, payload) {
    state.selectedMemberEmployers = payload;
  },
  selectedEmployer(state, payload) {
    state.selectedEmployer = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
